import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { post } from "../axios-post";

export const apiCallGetOtherAuditorsPerformance = async ({
  adminId,
  dateMin,
  dateMax
}: {
  adminId: number;
  dateMin: Date;
  dateMax: Date;
}): Promise<{
  data: {
    auditorsPerformanceData: {
      auditName: string;
      minor: number;
      major: number;
      no_issue: number;
      total: number;
    }[];
    auditorsEfficiencyData: [];
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    auditorsPerformanceData: {
      auditName: string;
      minor: number;
      major: number;
      no_issue: number;
      total: number;
    }[];
    auditorsEfficiencyData: [];
  }>(`supervisor/getOtherAuditorsPerformance`, {
    adminId,
    startDateObject: getDateAsObject(dateMin),
    endDateObject: getDateAsObject(dateMax)
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        auditorsPerformanceData: data.auditorsPerformanceData,
        auditorsEfficiencyData: data.auditorsEfficiencyData
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { auditorsPerformanceData: [], auditorsEfficiencyData: [] },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        auditorsPerformanceData: [],
        auditorsEfficiencyData: []
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
